import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
const RequestPool = lazy(() => import('../../pages/request-callback/request-pool'));
const RepliedByMe = lazy(() => import('../../pages/request-callback/replied-by-me'));
const VoiceCalls = lazy(() => import('../../pages/request-callback/voice-calls'));

function PagesRoute() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}/request-pool`} component={RequestPool} />
            <Route exact path={`${path}/replied-by-me`} component={RepliedByMe} />
            <Route exact path={`${path}/call-history`} component={VoiceCalls} />
        </Switch>
    );
}

export default PagesRoute;
